/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GuildTypes = "GUILD" | "NETWORK" | "%future added value";
export type GuildPrimaryPhoto_guild = {
    readonly type: GuildTypes | null;
    readonly primaryPhoto: {
        readonly " $fragmentRefs": FragmentRefs<"GraphQLImage_image">;
    } | null;
    readonly " $refType": "GuildPrimaryPhoto_guild";
};
export type GuildPrimaryPhoto_guild$data = GuildPrimaryPhoto_guild;
export type GuildPrimaryPhoto_guild$key = {
    readonly " $data"?: GuildPrimaryPhoto_guild$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"GuildPrimaryPhoto_guild">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildPrimaryPhoto_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "primaryPhoto",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GraphQLImage_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};
(node as any).hash = '61e2dd419521e1fae8ee50d5a3d9b200';
export default node;
